import React from "react";
import Hero from "./Hero";
import GirdMenu from "./GridMenu";
import Map from "./Map";
import GalerySlider from "./GalerySlider";

const Home = () => {
	return (
		<>
			<Hero></Hero>
			<GirdMenu></GirdMenu>
			<GalerySlider />
			<Map />
		</>
	);
};

export default Home;
